import React from "react";
import { useTranslation } from "react-i18next";
import SupportFloatingButton from "./SupportFloatingButton";
import SupportWidget from "./SupportWidget";
import MobileBottomNavigation from "../mobile/MobileBottomNavigation";
import { useSupport } from "../../hooks/useSupport";

/**
 * Один экран — один механизм поддержки.
 *
 * До 31.08.2026 здесь монтировались ДВА независимых состояния: `useSupport` со
 * своей сессией и лентой и `SupportWidget` со своей. Комментарий на этом месте
 * утверждал, что «лаунчер и виджет делят один инстанс useSupport», но виджету не
 * передавалось ни сообщений, ни сессии — он вёл собственную. Отсюда: пустая
 * сессия в БД на каждое открытие чата, эскалация не той сессии и мёртвые ворота
 * ТЗ §1.1 (см. F-SUP-2). Теперь `useSupport` — координатор (сессия, счётчик
 * попыток AI, запрос эскалации), а лента живёт только в виджете.
 */
const SupportWrapper: React.FC = () => {
  const { t } = useTranslation("support");
  const support = useSupport();

  return (
    <>
      <SupportFloatingButton
        position="bottom-right"
        showBadge={support.unreadCount > 0}
        proactiveHelp={true}
        openSupport={support.openSupport}
        requestEscalation={support.requestEscalation}
        isOpen={support.isOpen}
        unreadCount={support.unreadCount}
        canRequestOperator={support.canRequestOperator}
      />

      <SupportWidget
        open={support.isOpen}
        onClose={support.closeSupport}
        sessionId={support.sessionId}
        ensureSession={support.ensureSession}
        onAiReply={support.registerAiReply}
        canRequestOperator={support.canRequestOperator}
        escalationRequested={support.escalationRequested}
        onEscalationHandled={support.acknowledgeEscalation}
        {...(support.pendingInitialMessage != null
          ? { initialMessage: support.pendingInitialMessage }
          : {})}
        onInitialMessageSent={support.consumeInitialMessage}
      />

      {/* Mobile Navigation */}
      <MobileBottomNavigation
        showFloatingAction={true}
        hideOnScroll={true}
        onQuickAction={() => support.openSupport(t("quickHelp.createEvent"))}
      />
    </>
  );
};

export default SupportWrapper;
